<template>
	<div
		class="section hotspot-list"
		ref="hotspotListRef"
		:id="id"
		:class="showSimpleView ? 'hotspot-list--simple' : ''"
	>
		<div class="section__inner">
			<header class="section__intro inview">
				<h2 class="section__title">{{ title }}</h2>
			</header>
			<div class="carousel__wrapper">
				<div class="carousel__container">
					<div class="carousel__controls"></div>
					<div
						class="grid-1_smx-3-equalHeight hotspot-list__carousel"
					>
						<component
							:is="cardType"
							v-for="(item, index) in items"
							:key="index"
							:manchet="item.Manchet"
							:title="item.Title"
							:responsiveImageThreeColumns="
								item.ResponsiveImageThreeColumns
							"
							:link="item.Link"
							:dateText="item.DateText"
							:dateString="item.DateString"
							:endDateString="item.EndDateString"
							:timeString="item.TimeString"
							:disableLink="item.DisableLink"
							:showSimpleView="showSimpleView"
							:id="item.Id"
							:tags="item.Tags"
							:labelTime="labelTime"
							:labelDate="labelDate"
							:labelPrice="labelPrice"
							:labelPlace="labelPlace"
							:price="item.Price"
							:place="item.Place"
						>
						</component>
					</div>
				</div>
			</div>
			<div v-if="linkToMore" class="hotspot-list__morelinks grid">
				<div class="col-12 hotspot-list__morelinks-news">
					<a
						class="section__link"
						:href="linkToMore.Url"
						:target="linkToMore.Target"
						>{{ linkToMore.Name }}
						<span class="section__link-icon" v-html="IconChevron">
						</span>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import IconChevron from "../../../views/icons/chevron.cshtml";
import HotspotList from "./hotspotList.js";
import HotspotListCard from "./hotspotListCard.vue";
import HotspotListCardAlt from "./hotspotListCardAlt.vue";

const items = ref([]);
const title = ref("");
const id = ref("");
const linkToMore = ref({});
const showSimpleView = ref(false);
const cardType = ref(HotspotListCard);
const labelDate = ref("");
const labelTime = ref("");
const labelPrice = ref("");
const labelPlace = ref("");
const dataProps = ref({});

const hotspotListRef = ref("hotspotListRef");

onMounted(() => {
	setDataFromAttributes();

	nextTick(() => {
		new HotspotList({
			el: document.querySelector(".hotspot-list"),
		});
	});
});

const setDataFromAttributes = () => {
	dataProps.value = hotspotListRef.value?.parentElement?.dataset;
	if (dataProps.value) {
		items.value = JSON.parse(dataProps.value.items);
		id.value = dataProps.value.id;
		title.value = dataProps.value.title;
		linkToMore.value = JSON.parse(dataProps.value.linkToMore);
		showSimpleView.value = dataProps.value.showSimpleView == "True";
		labelTime.value = dataProps.value.labelTime;
		labelDate.value = dataProps.value.labelDate;
		labelPlace.value = dataProps.value.labelPlace;
		labelPrice.value = dataProps.value.labelPrice;
		setCardType();
	}
};

const setCardType = () => {
	if (dataProps.value && dataProps.value.cardType) {
		if (dataProps.value.cardType == "HotspotCardAlt") {
			cardType.value = HotspotListCardAlt;
		} else {
			cardType.value = HotspotListCard;
		}
	}
};
</script>
